import { TextStyle } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';
import { ticketSurfaces } from '../../../shared/ticket/ticketSurfaces.styles';

export const posCheckoutPaymentStyleDefs = {
  checkoutPaymentSection: {
    gap: spacing.sm,
  },

  /** Micro-caps `.sec-title` del proto, igual que los títulos de la columna ticket. */
  checkoutPaymentSectionTitle: {
    marginBottom: 0,
    fontSize: 11,
    fontWeight: '800',
    color: ticketColors.ink3,
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const,
    fontFamily: ticketFonts.sans,
  },

  checkoutPaymentDraftsStack: {
    gap: spacing.sm,
  },

  checkoutPaymentDraftPanel: {
    gap: spacing.sm,
  },

  checkoutPaymentDraftPanelSplit: {
    ...ticketSurfaces.paperSheet,
    ...ticketSurfaces.paperSheetPadded,
  },

  checkoutPaymentAmountInput: {
    backgroundColor: 'transparent',
    borderWidth: 0,
    paddingHorizontal: 0,
    paddingVertical: 0,
    fontSize: 28,
    fontWeight: '700',
    letterSpacing: -0.6,
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    minHeight: 36,
    fontFamily: ticketFonts.mono,
  },

  checkoutReceivedAmountRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },

  checkoutReceivedCurrency: {
    fontSize: 28,
    fontWeight: '700',
    letterSpacing: -0.6,
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    fontFamily: ticketFonts.mono,
    lineHeight: 36,
  },

  /** Bloque «Comprobante de pago» — sec-title + control dashed (proto `.attach`). */
  checkoutAttachBlock: {
    gap: 6,
  },

  checkoutAttachDashed: {
    borderStyle: 'dashed' as const,
  },

  checkoutReceivedBox: {
    ...ticketSurfaces.paperSheet,
    marginTop: 4,
    marginHorizontal: 2,
    paddingVertical: 14,
    paddingHorizontal: 16,
    maxWidth: '100%',
    gap: 6,
  },

  checkoutReceivedLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink3,
    letterSpacing: 0.2,
    fontFamily: ticketFonts.sans,
  },

  checkoutPickupNameBlock: {
    marginBottom: spacing.md,
    gap: 6,
  },

  checkoutPickupNameInput: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 15,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
    backgroundColor: ticketColors.paper,
  },

  checkoutReceivedDiff: {
    marginTop: 8,
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },

  checkoutReceivedDiffLabel: {
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
  },

  checkoutReceivedDiffValue: {
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '700',
    fontVariant: ['tabular-nums'] as TextStyle['fontVariant'],
    fontFamily: ticketFonts.mono,
  },

  checkoutReceivedDiffOk: {
    color: ticketColors.ok,
  },

  checkoutReceivedDiffWarn: {
    color: ticketColors.gold,
  },

  checkoutPaymentDraftLabel: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '700',
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    fontFamily: ticketFonts.sans,
  },

  /** Input compacto para el sub-form de cheque — el rail de pago es angosto (320-420px). */
  checkoutCheckInput: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    paddingHorizontal: 10,
    paddingVertical: 8,
    color: ticketColors.ink,
    backgroundColor: ticketColors.paper,
    fontSize: 13,
    fontWeight: '500',
    fontFamily: ticketFonts.sans,
    minHeight: 40,
  },

  checkoutAddPaymentButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    alignSelf: 'stretch',
    minHeight: 44,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: 'transparent',
  },

  checkoutAddPaymentButtonText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '700',
    textAlign: 'center',
    flexShrink: 1,
    fontFamily: ticketFonts.sans,
  },

  checkoutAddCheckButton: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 4,
    marginTop: 6,
    paddingVertical: 2,
  },

  checkoutAddCheckButtonText: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },

  /** Chips de comprobantes elegidos — rail angosto, versión compacta del chip del modal de cobro. */
  checkoutAttachmentChipRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderRadius: 8,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },

  checkoutAttachmentChipName: {
    fontSize: 12,
    color: ticketColors.ink,
    flex: 1,
    minWidth: 0,
    fontFamily: ticketFonts.sans,
  },

  checkoutAttachmentHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
} as const;
